/**
 * Rejection value for requests canceled via AbortController — thrown by
 * handleApiError (useHttpCalls) instead of resolving `undefined`, which is
 * indistinguishable from a real failure. With cancels rejecting typed, an
 * `undefined` resolution unambiguously means the request FAILED, so a call
 * site that forgets to handle cancellation surfaces as a dev-visible
 * unhandled rejection instead of a user-facing error state (T20-137309).
 */
export class RequestCancelledError extends Error {
  constructor() {
    super('Request cancelled');
    this.name = 'RequestCancelledError';
  }
}
